import { render } from "./cashier-settings-page.vue?vue&type=template&id=1286fc6e&ts=true"
import script from "./cashier-settings-page.ts?vue&type=script&lang=ts"
export * from "./cashier-settings-page.ts?vue&type=script&lang=ts"

import "./cashier-settings-page.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__